import React, { useContext } from 'react';
import cls from './ImageList.module.css';
import { ImageCard } from '../ImageCard/ImageCard';
import { EstimateMeasurementsContext } from '../../Context/EstimateMeasurementsContext';

export const ImageList = () => {
    const { imageList } = useContext(EstimateMeasurementsContext);
    return (
        <>
            <ul className={cls.ImageList}>
                {imageList.map((image, index) => (
                    <ImageCard
                        key={image.id}
                        src={image.previewUrl}
                        alt={image.file.name}
                        index={index}
                    />
                ))}
            </ul>
        </>
    );
};
